import { render } from "./users-statistic.vue?vue&type=template&id=f92d2ac6"
import script from "./users-statistic.vue?vue&type=script&lang=ts"
export * from "./users-statistic.vue?vue&type=script&lang=ts"

import "./users-statistic.vue?vue&type=style&index=0&id=f92d2ac6&lang=less"
script.render = render

export default script